import { isParticipantFormatVirtual } from '@/store/availableActions/utils/user/isParticipantFormatVirtual';
import { isParticipantFormatPhysical } from '@/store/availableActions/utils/user/isParticipantFormatPhysical';

export function isParticipantFormatVirtualAndPhysical(participant) {
  return isParticipantFormatVirtual(participant) && isParticipantFormatPhysical(participant);
}